import httpStatus from 'statuses'

// Abstract Product
const BaseErrorPage = (errorCode) => {
  let errorStatusText = ''
  try {
    errorStatusText = httpStatus(errorCode)
  } catch (error) {
    errorStatusText = 'Unknown'
  }

  return {
    // Properties
    showErrorCode: true,
    errorCode: errorCode,
    errorText: `${errorCode} ${errorStatusText}`,
    title: 'Uh oh!',
    desc: "We've sent our servers to timeout.",
    subDesc: 'Our servers encountered an error.',
    goBackURL: '/',
    goBackText: 'Back to Home',
  }
}

// Factory
export function ErrorPageFactory(errorCode) {
  switch (errorCode?.toString()) {
    case '500':
      return InternalServerError(errorCode)
    case '404':
      return PageNotFoundError(errorCode)
    case '401':
      return UnauthorizedError(errorCode)
    case '400':
      return BadRequestError(errorCode)
    case '117':
      return ActionLockedError(errorCode)
    case '001':
      return InviteExpiredError(errorCode)
    case '002':
      return AlreadyAcceptedInviteError(errorCode)
    default:
      return BaseErrorPage('500')
  }
}

// Concrete Products
const InternalServerError = (errorCode) => {
  return BaseErrorPage(errorCode)
}

const BadRequestError = () => {
  return BaseErrorPage('500')
}

const PageNotFoundError = (errorCode) => {
  return BaseErrorPage(errorCode)
}

const UnauthorizedError = (errorCode) => {
  const base = BaseErrorPage(errorCode)
  base.desc = 'A teacher caught you going out of bounds.'
  base.subDesc = "You don't have sufficient permissions to view this page."
  base.showErrorCode = false
  return base
}

const ActionLockedError = (errorCode) => {
  const base = BaseErrorPage(errorCode)

  base.desc =
    'Looks like someone was trying to use their pen without a pen license.'
  base.subDesc =
    'This action has been locked. Please verify your email address and try again.'
  base.showErrorCode = false
  return base
}

const InviteExpiredError = (errorCode) => {
  const base = BaseErrorPage(errorCode)
  base.title = 'Expired'
  base.desc = "We're sorry, this invitation has expired and cannot be viewed."
  base.subDesc = ''
  base.showErrorCode = false
  return base
}

const AlreadyAcceptedInviteError = (errorCode) => {
  const base = BaseErrorPage(errorCode)
  base.title = 'Expired'
  base.desc = 'This invitation has already been accepted'
  base.subDesc = 'There is no further action required'
  base.showErrorCode = false
  return base
}
